import { encode, decode } from "base64-arraybuffer";
import Resizer from "react-image-file-resizer";

// Formats files into the object expected for fileupload
export const formatFilesForUpload = (files, clickDispatchId, workOrderNumber, includeID = false) => {
    var filesToBeUploaded = [];
    for (var i = 0; i < files.length; i++) {
        var file = files[i];

        var formattedFile = {
            fileName: file.fullFileName,
            fileType: file.fileType,
            relatedJobId: clickDispatchId,
            relatedSourceId: workOrderNumber,
            data: file.data,
            fileDescription: file.fileDescription,
            uploadedBy: file.uploadedBy,
        };
        if (includeID) formattedFile.id = file.id;

        filesToBeUploaded.push(formattedFile);
    }

    return filesToBeUploaded;
};

// Formats files after selecting them in the input component
export const formatFileOnInput = (file, data, clickDispatchId, workOrderNumber, userName) => {
    var re = /(.+?)(?:\.([^.]+))?$/; // Captures file name and extension, if there
    var match = re.exec(file.name);
    var fileName = match && match[1] ? match[1] : "";
    var extension = match && match.length === 3 ? match[2] : "";
    const formattedFilename = fileName + "." + extension.toLowerCase();
    var formattedFile = {
        id: generateKey(file.name), // Create an ID to make removing easier
        fullFileName: formattedFilename, // Includes extension- [name].[extension]
        fileName, // Just filename, no extension
        fileDescription: "",
        fileType: file.type, // Gets extension from image/[type]
        extension: file.type.includes("image") ? file.type.split("/")[1] : extension,
        data,
        uploadedBy: userName,
    };
    if (clickDispatchId) formattedFile.relatedJobId = clickDispatchId;
    if (workOrderNumber) formattedFile.relatedSourceId = workOrderNumber;
    return formattedFile;
};

export const resizeFile = (file) => {
    return new Promise((resolve, reject) => {
        Resizer.imageFileResizer(
            file,
            1280,
            720,
            file.type.split("/")[1],
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "file",
        );
    });
};

export const convertByteArray = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = () => {
            let arrayBuffer = new Uint8Array(fileReader.result);
            resolve(encode(arrayBuffer));
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const handleDownload = (file) => {
    var elem = window.document.createElement("a");
    elem.href = `data:${file.fileType};base64,${file.data}`;
    elem.download = file.fileName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
};

export const generateKey = (file) => {
    return `${file}-${new Date().getTime()}`;
};

export const getSupportedFileExtensions = () => {
    const formats = process.env.REACT_APP_FILE_UPLOAD_SUPPORTEDFILEFORMATS;
    return formats ? formats.split(",").map((ext) => `.${ext.trim().toLowerCase()}`) : [];
};

export const isImage = (ext) => {
    const allwoedImageFormats = process.env.REACT_APP_SUPPORTED_IMAGE_FORMATS?.split(",") ?? [];

    return allwoedImageFormats.some((opt) => ext.toLowerCase().includes(opt));
};

export const isValidImageExt = (ext, allowedFileExtensions = []) => {
    const allowedFileFormats =
        allowedFileExtensions.length > 0
            ? allowedFileExtensions.split(",")
            : process.env.REACT_APP_FILE_UPLOAD_SUPPORTEDFILEFORMATS?.split(",") ?? [];

    return allowedFileFormats.some((opt) => ext.toLowerCase().includes(opt));
};
export const acceptExtension = (extStr = "") =>
    [
        ...new Set(
            extStr
                .split(",")
                .map((extensionString) => extensionString.trim().toLowerCase())
                .filter(Boolean)
                .map((extensions) => (extensions.includes("/") ? extensions : extensions.startsWith(".") ? extensions : `.${extensions}`)),
        ),
    ].join(",");
